import { UrlHelper as PortfolioUrlHelper } from '@ecm/portfolio';

export const UrlHelper = {
    /**
     * Performs CID regex match on given url
     * @deprecated use `UrlHelper.matchCid` from `ecm-portfolio` instead
     * @param {string} url
     * @returns {string[]}
     */
    // eslint-disable-next-line deprecation/deprecation -- bug in deprecation plugin
    matchCid: (url: string): string[] => {
        return PortfolioUrlHelper.matchCid(url);
    },
    /**
     * Checks if provided url is external
     * @deprecated use `UrlHelper.matchCid` from `ecm-portfolio` instead
     * @param {string} url
     * @returns {boolean}
     */
    // eslint-disable-next-line deprecation/deprecation -- bug in deprecation plugin
    isExternalUrl: (url: string): boolean => {
        return PortfolioUrlHelper.isExternalUrl(url);
    },
    /**
     * Checks if provided url matches `.orange.fr` domain
     * @param {string} url
     * @returns {boolean}
     */
    isOrangeUrl(url: string): boolean {
        return UrlHelper.isDomainUrl(url, '.orange.fr');
    },
    /**
     * Checks if provided url matches `.sosh.fr` domain
     * @param {string} url
     * @returns {boolean}
     */
    isSoshUrl: (url: string): boolean => {
        return UrlHelper.isDomainUrl(url, '.sosh.fr');
    },
    /**
     * Checks if provided url matches provided domain
     * @param {string} url
     * @param {string} domain
     * @returns {boolean}
     */
    isDomainUrl: (url: string, domain: string): boolean => {
        const hostName: string = UrlHelper.getHostnameFromUrl(url);
        return hostName ? hostName.endsWith(domain) : false;
    },
    /**
     * Extracts hostname from provided url
     * @param {string} url
     * @returns {string}
     */
    getHostnameFromUrl: (url: string): string => {
        if (<any>window.document) {
            // instantiate native anchor element to extract hostname
            const link = document.createElement('a');
            link.href = url;
            return link.hostname;
        }
        return null;
    },
};
